import { useWatch } from "antd/es/form/Form";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { AllConfigurableFields, ConfigurableField } from "../types/Config";
import { FieldConfigSelect } from "./FieldConfigSelect";

type OnAddParams = {
  name: ConfigurableField;
};

type Props = {
  onAdd: (params: OnAddParams) => void;
  name: Array<string | number>;
};

export const AddFieldConfig = observer((props: Props) => {
  const fields = useWatch(props.name);
  const alreadySelected = useMemo(
    () => fields?.map((field: OnAddParams) => field.name) ?? [],
    [fields]
  );

  return (
    <>
      {alreadySelected.length < AllConfigurableFields.length && (
        <FieldConfigSelect
          onChange={(value) => props.onAdd({ name: value })}
          alreadySelected={alreadySelected}
        />
      )}
    </>
  );
});
